import { DashboardPeriod, PERIOD_LABELS } from '@/lib/api/dashboard/dashboard-api'
import { MdDateRange } from 'react-icons/md'

interface PeriodSelectorProps {
    value: DashboardPeriod
    onChange: (period: DashboardPeriod) => void
    startDate?: string
    endDate?: string
    onCustomDatesChange?: (startDate: string, endDate: string) => void
}

const periods: DashboardPeriod[] = ['today', 'week', 'month', 'quarter', 'year', 'custom']

export default function PeriodSelector({
    value,
    onChange,
    startDate = '',
    endDate = '',
    onCustomDatesChange,
}: PeriodSelectorProps) {
    const handleCustomStart = (v: string) => {
        onCustomDatesChange?.(v, endDate)
    }
    const handleCustomEnd = (v: string) => {
        onCustomDatesChange?.(startDate, v)
    }

    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-wrap gap-2">
                {periods.map(period => (
                    <button
                        key={period}
                        onClick={() => onChange(period)}
                        className={`btn btn-sm ${value === period
                                ? 'btn-secondary'
                                : 'btn-ghost border border-base-300'
                            }`}
                    >
                        {period === 'custom' && (
                            <MdDateRange className="text-base" />
                        )}
                        {PERIOD_LABELS[period]}
                    </button>
                ))}
            </div>

            {value === 'custom' && (
                <div className="flex flex-wrap items-end gap-3 bg-base-100 border border-base-300 rounded-lg p-3">
                    <div className="form-control">
                        <label className="label py-1">
                            <span className="label-text text-xs font-medium">
                                Data inicial
                            </span>
                        </label>
                        <input
                            type="date"
                            className="input input-bordered input-sm"
                            value={startDate}
                            max={endDate || undefined}
                            onChange={e => handleCustomStart(e.target.value)}
                        />
                    </div>
                    <div className="form-control">
                        <label className="label py-1">
                            <span className="label-text text-xs font-medium">
                                Data final
                            </span>
                        </label>
                        <input
                            type="date"
                            className="input input-bordered input-sm"
                            value={endDate}
                            min={startDate || undefined}
                            onChange={e => handleCustomEnd(e.target.value)}
                        />
                    </div>
                    {(!startDate || !endDate) && (
                        <span className="text-xs text-base-content/60 pb-2">
                            Selecione ambas as datas para aplicar.
                        </span>
                    )}
                </div>
            )}
        </div>
    )
}
